import { profiloAziendaFutura } from "./fixtures/profilo-azienda";

export type ProfiloAzienda = {
  brand: string;
  studio: string;
  descrizione: string;
  sede: string;
  email: string;
  telefono: string;
  membri: number;
};

const wait = (milliseconds: number) => new Promise((resolve) => setTimeout(resolve, milliseconds));

export async function getProfiloAzienda(): Promise<ProfiloAzienda> {
  await wait(160);
  return { ...profiloAziendaFutura };
}
